import { render, staticRenderFns } from "./state-criticity-field.vue?vue&type=template&id=225fb37d&"
import script from "./state-criticity-field.vue?vue&type=script&lang=js&"
export * from "./state-criticity-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports